import $ from 'jquery';

const bodyHtml = $('body,html');
const body = $('body');

/* ======================================
body fix
====================================== */
let scrollPosi;

function bodyFix() {
	scrollPosi = $(window).scrollTop();

	body.addClass('is-fixed');
	body.css({ top: -scrollPosi });
}

function bodyFixReset() {
	body.removeClass('is-fixed');
	body.removeAttr('style');
	bodyHtml.scrollTop(scrollPosi);
}

// $(window).on('scroll', function () {
// 	$('.js-header').css('left', -$(window).scrollLeft())
// })

$(function () {
	const btnMenu = $('.js-header-btn');
	const header = $('.js-header');
	const btnMenuText = $('.js-header-btntext');
	const menus = $('.c-header__menus');

	if (btnMenu.length) {
		btnMenu.on('click', function () {
			header.toggleClass('is-active');
			btnMenu.toggleClass('is-active');

			if (btnMenu.hasClass('is-active')) {
				btnMenuText.text('閉じる');
			} else {
				btnMenuText.text('メニュー');
			}

			if (btnMenu.hasClass('is-active')) {
				if ($(window).outerWidth() < 751) {
					bodyFix();
				}
			} else {
				if ($(window).outerWidth() < 751) {
					bodyFixReset();
				}
			}
		});

		if ($('.js-header-bottom').length) {
			header.addClass('u-style2');
		}

		$(window).on('click', function (e) {
			if ($(e.target).is('.c-header__menus')) {
				bodyFixReset();
				btnMenu.removeClass('is-active');
				header.removeClass('is-active');
				btnMenuText.text('メニュー');
			}
		});

		$(window).on('resize scroll', function () {
			if ($(window).outerWidth() > 749) {
				bodyFixReset();
				btnMenu.removeClass('is-active');
				header.removeClass('is-active');
				btnMenuText.text('メニュー');
			}
		});

		$(window).on('load resize', function () {
			const hWindow = $(window).innerHeight();

			menus.css('height', hWindow);

			if ($(window).outerWidth() > 749) {
				menus.removeAttr('style');
			}
		});
	}

	function iPad() {
		return (
			['iPad Simulator', 'iPad'].includes(navigator.platform) ||
			(navigator.userAgent.includes('Mac') && 'ontouchend' in document)
		);
	}

	function getiOSVersion() {
		const match = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
		if (match !== null) {
			var version = [
				parseInt(match[1], 10),
				parseInt(match[2], 10),
				parseInt(match[3] || 0, 10),
			];
			return version.join('.');
		}
		return 'Not an iOS device';
	}

	const iOSVersion = Number(getiOSVersion().slice(0, 2));

	if (iPad()) {
		if (iOSVersion === 13) {
			$('body').addClass('is-ios-old');
		}
	}
});
